/* App-link measurement follows Shopify's regional consent decisions. It never sends form values or account identifiers. */
(() => {
  if (/^\/(account|cart|checkout|checkouts|orders)(\/|$)/.test(location.pathname)) return;
  const id='G-3DVK83JMML'; let enabled=false,started=false;
  const clean=(value)=>{try{const u=new URL(value);return u.origin+u.pathname;}catch{return '';}};
  const privacy=()=>window.Shopify?.customerPrivacy;
  function sync(){
    enabled=!navigator.globalPrivacyControl&&!window.globalPrivacyControl&&privacy()?.analyticsProcessingAllowed()===true;
    window[`ga-disable-${id}`]=!enabled;
    if(!enabled){
      if(started)window.gtag?.('consent','update',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      return;
    }
    window.dataLayer=window.dataLayer||[];
    window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};
    if(!started){
      window.gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      window.gtag('consent','update',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      window.gtag('js',new Date());
      window.gtag('config',id,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:clean(location.href),page_referrer:clean(document.referrer)});
      const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+id;document.head.appendChild(script);started=true;
    } else window.gtag('consent','update',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  }
  document.addEventListener('visitorConsentCollected',sync);
  document.addEventListener('click',(event)=>{
    if(!enabled||navigator.globalPrivacyControl||privacy()?.analyticsProcessingAllowed()!==true)return;
    const a=event.target.closest?.('a[href]'); if(!a)return;
    const u=new URL(a.href); if(u.hostname!=='club.infusionlabcoffee.com'||u.pathname!=='/go/app')return;
    const allowed=['hero-order','hero-store','navigation','footer','join','app-page','passport','menu','other'];
    const raw=u.searchParams.get('placement');
    window.gtag?.('event','app_store_click',{source_site:'main',placement:allowed.includes(raw)?raw:'other',page_location:clean(location.href),page_referrer:clean(document.referrer),transport_type:'beacon'});
  },{capture:true});
  if(privacy())sync(); else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)sync();});
})();
